export const CREATE_TICKET_MODAL = 'CREATE_TICKET_MODAL';
export const THANK_YOU_MODAL = 'THANK_YOU_MODAL';
export const REPLY_TICKET_MODAL = 'REPLY_TICKET_MODAL';
export const FULL_SIZE_IMAGE_MODAL = 'FULL_SIZE_IMAGE_MODAL';
